import logo from 'assets/images/logo.png';

// ==============================|| LOGO ||============================== //

const Logo = ({ imageSize = 50, visibleTitle = true }) => {
    return (
        <>
            <img src={logo} alt="Gardener" height={imageSize} />
            {visibleTitle && <span className="gd-logo__title">GARDENER</span>}
        </>
    );
};

export default Logo;
